/**
 * Register
 *
 * @module views/auth/registration-confirm
 */
define('views/auth/registration-confirm',['require','jquery','mediator','helpers/application','views/base/form','text!templates/auth/registration-confirm.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        mediator = require('mediator'),
        applicationHelper = require('helpers/application'),
        FormView = require('views/base/form'),
        template = require('text!templates/auth/registration-confirm.ejs');

    var RegisterConfirmView = FormView.extend({
        template: template,
        className: 'registration-form modal-backdrop dark in',
        region: 'session',
        customValidation: true,

        events: {
            'click [data-action=back]': 'back',
        },

        back: function(event){
            event.preventDefault();
            applicationHelper.redirectTo('auth#login', {}, { forceStartup: true });
        },

        save: function() {
            var _this = this;
            var model = this.model;

            model.save()
                .done(function(response) {
                    console.log('done', arguments);
                    mediator
                        .signin(response.accessToken)
                        .done(function() {
                            applicationHelper.redirectTo('dashboard#show', {}, { forceStartup: true });
                        });
                })
                .fail(function() {
                    console.log('fail', arguments);

                    _this.errorMessages = ['Вы ввели неправильный пароль либо ссылка восстановления просрочена.'];
                    _this.render();
                });
        }
    });

    return RegisterConfirmView;
});

